// extracted by mini-css-extract-plugin
module.exports = {"realStory":"RealStory_realStory__xW5aE","imgScale":"RealStory_imgScale__toXWP","imgScale2":"RealStory_imgScale2__5ObLo"};